import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function RecruitersIcon({ className }: IconProps) {
  return (
    <svg
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_647)">
        <path
          d="M71.3225 17.2157C70.4034 17.2157 69.6681 16.4802 69.6681 15.5608V5.12563C69.6681 4.11429 68.8409 3.30982 67.8528 3.30982H57.421C56.5019 3.30982 55.7666 2.57431 55.7666 1.65491C55.7666 0.735516 56.5019 0 57.421 0H67.8528C70.6791 0 72.9769 2.29849 72.9769 5.12563V15.5608C72.9769 16.4802 72.2416 17.2157 71.3225 17.2157Z"
          fill="#00416B"
        />
        <path
          d="M1.65439 17.2157C0.735285 17.2157 0 16.4802 0 15.5608V5.12563C0 2.29849 2.29777 0 5.14699 0H15.5788C16.498 0 17.2332 0.735516 17.2332 1.65491C17.2332 2.57431 16.498 3.30982 15.5788 3.30982H5.14699C4.13598 3.30982 3.33176 4.11429 3.33176 5.12563V15.5608C3.33176 16.4802 2.59647 17.2157 1.67737 17.2157"
          fill="#00416B"
        />
        <path
          d="M15.5559 73.0001H5.14699C2.32074 73.0001 0 70.7016 0 67.8745V57.4393C0 56.5199 0.735285 55.7844 1.65439 55.7844C2.5735 55.7844 3.30878 56.5199 3.30878 57.4393V67.8745C3.30878 68.8628 4.113 69.6903 5.12402 69.6903H15.5559C16.475 69.6903 17.2103 70.4258 17.2103 71.3452C17.2103 72.2646 16.475 73.0001 15.5559 73.0001Z"
          fill="#00416B"
        />
        <path
          d="M67.8528 73.0001H57.421C56.5019 73.0001 55.7666 72.2646 55.7666 71.3452C55.7666 70.4258 56.5019 69.6903 57.421 69.6903H67.8528C68.8639 69.6903 69.6681 68.8628 69.6681 67.8745V57.4393C69.6681 56.5199 70.4034 55.7844 71.3225 55.7844C72.2416 55.7844 72.9769 56.5199 72.9769 57.4393V67.8745C72.9769 70.7016 70.6791 73.0001 67.8528 73.0001Z"
          fill="#00416B"
        />
        <path
          d="M37.2233 38.6489C26.8604 38.6489 18.2897 46.3948 16.98 56.4162C16.7962 57.8183 17.8991 59.0825 19.3237 59.0825H55.0999C56.5246 59.0825 57.6275 57.8413 57.4437 56.4162C56.1339 46.3948 47.5863 38.6489 37.2004 38.6489"
          fill="#00C4B3"
        />
        <path
          d="M52.9402 27.6621C52.9402 36.3274 45.909 43.3607 37.2465 43.3607C28.5839 43.3607 21.5527 36.3274 21.5527 27.6621C21.5527 18.9968 28.5839 11.9634 37.2465 11.9634C45.909 11.9634 52.9402 18.9968 52.9402 27.6621Z"
          fill="white"
        />
        <path
          d="M48.2303 27.6621C48.2303 33.7301 43.3131 38.6488 37.247 38.6488C31.1809 38.6488 26.2637 33.7301 26.2637 27.6621C26.2637 21.5941 31.1809 16.6753 37.247 16.6753C43.3131 16.6753 48.2303 21.5941 48.2303 27.6621Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_647">
          <rect width="73" height="73" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
